import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import { defaultLocale } from '../config/i18n.config';
import { LocaleProvider } from '../context/localeContext';
import Layout from '../components/Layout';
import GenericPage from './GenericPage';
import Section from '../components/Section';

const DonationPageTemplate = ({ data, pageContext }) => {
  const { frontmatter: page } = data.markdownRemark;

  return (
    <LocaleProvider locale={pageContext.locale}>
      <Layout>
        <GenericPage
          title={page[defaultLocale].title}
          heroImage={page[defaultLocale].image}
          heroContent={page[defaultLocale].hero}
          pageContent={page[defaultLocale].body}
        />
        <Section colorScheme="white">
          <div className="pb-12">
            <script type="module" src="https://donorbox.org/widgets.js" async></script>
            <dbox-widget campaign="gdi-donations-2026" type="donation_form" interval="1 M" amount="30" enable-auto-scroll="true"></dbox-widget>
          </div>
        </Section>
      </Layout>
    </LocaleProvider>
  );
};

DonationPageTemplate.propTypes = {
  data: PropTypes.object.isRequired,
};

export default DonationPageTemplate;

export const donationPageQuery = graphql`
  query DonationPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        en {
          title
          hero
          body
          image {
            childImageSharp {
              gatsbyImageData(quality: 100, layout: FULL_WIDTH)
            }
          }
        }
        de {
          title
          hero
          body
          image {
            childImageSharp {
              gatsbyImageData(quality: 100, layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
`;
